import type { AxiosRequestConfig } from 'axios';

import { HttpHeader } from '@rygen/rygen-ui/model';

import { useCurrentUserStore } from '@/stores/CurrentUser';
import { useParentEntityStore } from '@/stores/ParentEntity';

export default async (
  config: AxiosRequestConfig,
  canIncludeSubDomains = false,
  useSelectedDomainContext = false,
): Promise<AxiosRequestConfig> => {
  if (config.headers?.[HttpHeader.DOMAIN]) {
    return config;
  }

  const { selectedDomainId } = useCurrentUserStore();
  const { includeSubDomains, owningClient } = useParentEntityStore();

  const domainToLoadAs =
    config.params?.useSelectedDomainContext || useSelectedDomainContext
      ? selectedDomainId.value
      : (owningClient.value?.id ?? selectedDomainId.value);
  if (domainToLoadAs && config.headers) {
    config.headers[HttpHeader.DOMAIN] = domainToLoadAs;
  }

  if (config.params?.useSelectedDomainContext) {
    delete config.params.useSelectedDomainContext;
  }

  if (canIncludeSubDomains && includeSubDomains.value) {
    const isGetRequest = config.method?.toUpperCase() === 'GET';
    const existingParams = (isGetRequest ? config.params : config.data) ?? {};
    const updatedParams = {
      ...existingParams,
      includeSubDomains: true,
    };

    if (isGetRequest) {
      config.params = updatedParams;
    } else {
      config.data = updatedParams;
    }
  }

  return config;
};
